import { z } from 'zod';

export interface RadioOption {
  value: string | boolean;
  label: string;
}

export const observedPrimitiveSchema = z.union([
  z.string(),
  z.number(),
  z.boolean(),
  z.bigint(),
]);
const booleanSchema = z.boolean();
type ObservedPrimitive = z.infer<typeof observedPrimitiveSchema>;

export function includeObservedRadioOption(
  options: ReadonlyArray<RadioOption>,
  observedValue: ObservedPrimitive | undefined,
  observedLabel: ObservedPrimitive | undefined,
): ReadonlyArray<RadioOption> {
  const normalizedValue = observedValue === undefined ? '' : String(observedValue);

  if (
    normalizedValue === ''
    || options.some((option) => String(option.value) === normalizedValue)
  ) {
    return options;
  }

  const normalizedLabel = observedLabel === undefined ? '' : String(observedLabel).trim();
  const observedBoolean = booleanSchema.safeParse(observedValue);
  return [
    {
      value: observedBoolean.success ? observedBoolean.data : normalizedValue,
      label: normalizedLabel || normalizedValue,
    },
    ...options,
  ];
}
